module.exports = __webpack_public_path__ + "static/media/shoe_04.a2a04ea9.jpg";